import { render } from "./MultiDiskSelection.vue?vue&type=template&id=22dcddfc&scoped=true"
import script from "./MultiDiskSelection.vue?vue&type=script&lang=js"
export * from "./MultiDiskSelection.vue?vue&type=script&lang=js"

import "./MultiDiskSelection.vue?vue&type=style&index=0&id=22dcddfc&lang=less&scoped=true"

import exportComponent from "/root/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22dcddfc"]])

export default __exports__